import { useTranslate } from "@similarweb/i18n-provider";
import type { LineGraphProps } from "@similarweb/pro-logic-components";
import { LineGraph } from "@similarweb/pro-logic-components";
import { Box } from "@similarweb/ui-components/foundations";

import {
    LEGEND_GRAPH_GAP,
    LEGENDS_WITH_VALUE_MAX_WIDTH,
    LINE_CHART_LEGEND_HEIGHT,
    LINE_CHART_LEGEND_MIN_WIDTH,
    MAX_LEGEND_ITEMS_SELECTED,
} from "./constants";
import type { DataItem } from "./types";
import type { UseControlledGraphDataParams } from "./useControlledGraphData";
import { useControlledGraphData } from "./useControlledGraphData";
import { useLineChartConfig } from "./useLineChartConfig";

export type MetricWidgetLineGraphProps = UseControlledGraphDataParams &
    Pick<LineGraphProps<DataItem>, "legendHeaders"> & {
        isMonthly?: boolean;
    };

export const MetricWidgetLineGraph = ({ data, isMonthly, legendHeaders }: MetricWidgetLineGraphProps) => {
    const { translate } = useTranslate();
    const graphConfig = useLineChartConfig(isMonthly);

    const { controlledData, legendToggleHandlerCallback } = useControlledGraphData({
        data,
    });

    return (
        <Box padding="24px">
            {/* @ts-ignore FIXME: Type '(props: LegendItemProps) => ReactElement' is not assignable to type 'FunctionComponent<unknown>'. */}
            <LineGraph<DataItem>
                data={controlledData}
                graphConfig={graphConfig}
                isLegendSearch
                legendGraphGap={LEGEND_GRAPH_GAP}
                legendHeaders={legendHeaders}
                legendPosition="right"
                legendToggleHandlerCallback={legendToggleHandlerCallback}
                legendSearchPlaceholder={translate("common.placeholder.search.domain")}
                legendsHeight={LINE_CHART_LEGEND_HEIGHT}
                legendsMinWidth={LINE_CHART_LEGEND_MIN_WIDTH}
                legendsWithValueMaxWidth={LEGENDS_WITH_VALUE_MAX_WIDTH}
                // @ts-expect-error legendValueFilter should also support number
                // as winner is selected based on direct comparison of value
                // which doesn't work properly with strings
                legendValueFilter={(value) => value}
                maxLegendItemsSelected={MAX_LEGEND_ITEMS_SELECTED}
                presentWinner
                shouldPresentValueAtLegend
                withMarkers={false}
                withoutTooltipsPadding={false}
                isControlledGraph
            />
        </Box>
    );
};
